/**
 * Читає початкові значення фільтра завдань із query-рядка URL.
 *
 * Сторінки завдань (/assignments/with-requests, /assignments/without-requests)
 * не проходять через UniversalResourcePage, тому query → filter.initialValues
 * робимо тут. Переходи з головної (DashboardLinks):
 * - `status` — статус (етап воронки);
 * - `delayStatus` — статуси затримки через кому («Затримки без результату»);
 * - `noDriver=1` / `noVehicle=1` — активні задачі без водія / ТЗ;
 * - `dispatcher` (uuid) + `dispatcherName` — відповідальний диспетчер, як на головній.
 *
 * @example assignmentFilterFromQuery('?status=loading_started') // { status: 'loading_started' }
 */
export function assignmentFilterFromQuery(search: string): Record<string, any> | null {
    if (!search) return null
    const params = new URLSearchParams(search)
    const result: Record<string, any> = {}

    const status = params.get('status')
    if (status) result['status'] = status

    const delayStatus = params.get('delayStatus')
    if (delayStatus) result['delayStatus'] = delayStatus.split(',').filter(Boolean)

    // «Без водія / ТЗ» — лише серед незавершених задач, як лічильник на головній
    if (params.get('noDriver') === '1') result['noDriver'] = true
    if (params.get('noVehicle') === '1') result['noVehicle'] = true
    if (result['noDriver'] || result['noVehicle']) result['activeStatus'] = 'active'

    const dispatcher = params.get('dispatcher')
    if (dispatcher && /^[0-9a-f-]{36}$/i.test(dispatcher)) {
        const name = params.get('dispatcherName') || 'Диспетчер'
        // Значення мультиселекта — об'єкт сутності з @id (FilterResourceMultiSelect)
        result['filterDispatcher'] = [
            { '@id': `/services/users/${dispatcher}`, uuid: dispatcher, fullName: name, shortName: name },
        ]
    }

    return Object.keys(result).length > 0 ? result : null
}

/** Параметри переходу з головної, яких немає серед ключів фільтра (їх не прибирає applyInitialFilter) */
const DASHBOARD_ONLY_KEYS = ['noDriver', 'noVehicle', 'dispatcher', 'dispatcherName']

/**
 * Прибирає з URL службові параметри переходу після застосування фільтра (як applyInitialFilter
 * для ключів фільтра), щоб «Скинути все» не повертало їх після оновлення сторінки.
 */
export function stripDashboardQuery(): void {
    if (typeof window === 'undefined' || !window.history?.replaceState) return
    const url = new URL(window.location.href)
    let changed = false
    DASHBOARD_ONLY_KEYS.forEach((key) => {
        if (url.searchParams.has(key)) {
            url.searchParams.delete(key)
            changed = true
        }
    })
    if (changed) window.history.replaceState(window.history.state, '', url.toString())
}
